import { render, staticRenderFns } from "./SLinkType.vue?vue&type=template&id=85bee964&"
import script from "./SLinkType.vue?vue&type=script&lang=js&"
export * from "./SLinkType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports